<template lang="html">
  <v-page class="page-terms">
    <v-container>
      <v-row class="justify-content-center">
        <v-col :md="9">
          <v-logo />

          <div class="terms-text" role="article">
            <h1>
              POR FAVOR, PARA PROSSEGUIR COM A UTILIZAÇÃO DA PLATAFORMA VIBBRA,
              É IMPORTANTE QUE VOCÊ LEIA ATENCIOSAMENTE, ENTENDA E CONCORDE COM
              OS TERMOS SEGUINTES.
            </h1>

            <p>Última modificação: 08 de Julho de 2019.</p>

            <p>
              Em caso de discordância do que será disposto abaixo, você deverá
              cessar imediatamente a utilização da Plataforma, bem como qualquer
              outra funcionalidade oferecida pela Vibbra. Sempre que necessário,
              contate a Vibbra através do e-mail <b>suporte@vibbra.com.br</b>.
            </p>

            <p>1.1. Declaro que concordo e tenho pleno conhecimento:</p>

            <p>
              1.1.1. Dos direitos e obrigações decorrentes dos
              <v-link :to="{ name: 'terms' }" target="_blank"
                ><b
                  >Termos e Condições Gerais de Uso da Plataforma Vibbra</b
                ></v-link
              >, constituindo este instrumento o acordo entre as partes.
              Declaro, ainda, ter lido, compreendido e aceito todos os seus
              termos e condições, sobretudo com relação a taxa retida pela
              Vibbra e condições para pagamento a ser realizado;
            </p>

            <p>
              1.1.2. Que fui devidamente informado a respeito da
              <v-link :to="{ name: 'privacy' }" target="_blank"
                ><b>Política de Privacidade da Vibbra</b></v-link
              >, consentindo livre e expressamente com a referida política;
            </p>

            <p>
              1.1.3. Que todos os profissionais disponibilizados pela Plataforma
              Vibbra são cuidadosamente selecionados e devidamente instruídos
              por meio de manuais e guias de boas práticas na condução de suas
              atividades. No entanto, a Vibbra não responde pela gestão das
              atividades executadas pelos Usuários Profissionais, nem pela
              qualidade das atividades ou projetos realizados pelos Usuários
              Profissionais.
            </p>

            <p>
              1.1.4. Que não poderei abordar, negociar e/ou contratar
              diretamente os profissionais apresentados pela Vibbra, sujeito a
              pena de multa na importância de R$ 100.000,00 (cem mil reais), bem
              como outras penalidades legais aplicáveis, assim como a suspensão
              imediata da Plataforma Vibbra. Havendo esse interesse, é
              necessário contatar a Vibbra para que a mesma então avalie e dê
              seu parecer sobre o caso.
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-page>
</template>

<script>
export default {};
</script>

<style lang="scss">
.terms-text {
  font-size: 0.9em;
  h1 {
    font-size: 1.8em;
  }
  h2 {
    font-size: 1.6em;
  }
}
.page-terms {
  .logo {
    width: 200px;
    margin: 0 auto 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/accept.vue